import { render, staticRenderFns } from "./DeleteInstallationModal.vue?vue&type=template&id=6b2781f1&scoped=true&class=fill-height"
import script from "./DeleteInstallationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteInstallationModal.vue?vue&type=script&lang=ts"
import style0 from "./DeleteInstallationModal.vue?vue&type=style&index=0&id=6b2781f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2781f1",
  null
  
)

export default component.exports